import {
  addFieldData,
  addSubStep,
  alertDialog,
  alertDialogGoToBeginning,
  alertDialogGoToNext,
  nextStep,
  setItemBreadcrumbs,
  setMessage,
  setMessageWithCode,
  setPractitioners,
  setReturnedValue,
  setShowCodePrioritaire,
  setStepByPass,
  stopLoading
} from "../../actions";
import {
  fetcher,
  getReturnedValue,
  goToNextStep,
  initValues
} from "../fetcher";
import { processAppointments } from "../appointment";
import { getProtocol } from "../protocole";
import { store } from "../../store";
import * as CalendarHelper from "../../utils/calendar";
import { DateTime } from "luxon";
import { createStep, searchStepByCode } from "../scenario-manager";
import GoToLink from "../../components/question/GoToLink";
import { translator } from "../i18n";
import ChooserTypeConsultation from "../../components/ChooserTypeConsultation";

export const getUrls = () => ({
  getResponse: "ajax/get_reponse_react.php",
  getQuestion: "ajax/get_question_react.php",
  connexion: "ajax/connexion_widget_post.php",
  subscribe: "ajax/inscription_widget_post_ajax.php",
  getUser: "ajax/get_info_user.php",
  confirm: "ajax/confirmation_rdv.php",
  alterAppointment: "ajax/modification_user_rdv.php",
  summaryReport: "ajax/recap_rdv.php",
  faq: "cache_ajax/faq_widget.php",
  listUserComplete: "ajax/get_user_liste_complete_ajax.php",
  addUserAnnex: "ajax/add_user_annexe.php",
  editListUsers: "ajax/modification_liste_user_rdv.php",
  recapRdv: "ajax/recap_rdv_ajax.php",
  forgotPassword: "api_patient/reset-password",
  lbv: "ajax/api_lbv.php",
  infoRdvToken: "ajax/info_rdv_token.php",
  contact: "ajax/nous_contacter.php",
  controlPriorityCode: "ajax/ctrl_validation_code.php"
});

export const getProfessionalType = () => {
  return dispatch => {
    fetcher()
      .get("ajax/widget_liste_categorie.php")
      .then(response => response.json())
      .then(json => {
        // const jsonListe = [...jso.liste, jso.liste[0]];
        // const json = {
        //   "success": 1,
        //   "message_error": "",
        //   "liste":jsonListe,
        // }
        const bPassProf = store.getState().configuration.bPassProf;
        if (bPassProf) {
          dispatch(goToNextStep("professionalType", json, true, null));
        } else {
          if (json.success !== 1) {
            dispatch(setMessageWithCode({ text: json.message_error, code: 1 }));
            dispatch(stopLoading());
          } else if (json.liste) {
            dispatch(
              goToNextStep(
                "professionalType",
                json,
                json.liste.length === 1,
                json.liste.length === 1 ? json.liste[0].id : null
              )
            );
          } else {
            dispatch(
              setMessageWithCode({
                text: "Champ liste manquant dans le retour !",
                code: 1
              })
            );
            dispatch(stopLoading());
          }
        }
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getProfession = () => {
  return dispatch => {
    fetcher()
      .get("ajax/widget_liste_profession.php", {
        searchParams: {
          idcatprofession: getReturnedValue("professionalType"),
          provenance: "web"
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success !== 1 || !json.liste || json.liste.length === 0) {
          const bPassProf = store.getState().configuration.bPassProf;
          if (bPassProf) {
            dispatch(goToNextStep("professionalType", json, true, null));
          } else {
            dispatch(setMessageWithCode({ text: json.message_html, code: 1 }));
            dispatch(stopLoading());
          }
        } else {
          dispatch(
            goToNextStep(
              "profession",
              json,
              json.liste.length === 1,
              json.liste.length === 1 ? json.liste[0].id : null
            )
          );
        }
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getAppointmentType = () => {
  return (dispatch, getState) => {
    const params = {
      idprofession: getReturnedValue("profession"),
      provenance: "web",
      all: "1"
    };
    const definedValues = initValues();

    if ("appointmentType" in definedValues) {
      params["idtyperdv"] = definedValues.appointmentType;
    }
    fetcher()
      .get("ajax/widget_liste_type_rdv.php", {
        searchParams: params
      })
      .then(response => response.json())
      .then(json => {
        // if one result and if it's "protocol"
        if (json.success && json.success === "nop") {
          dispatch(setMessageWithCode({ text: json.message, code: 1 }));
          dispatch(stopLoading());
        } else if (
          json.length === 1 &&
          "success" in json[0] &&
          json[0].success === 0
        ) {
          dispatch(
            setMessageWithCode({ text: json[0].message_error, code: 1 })
          );
          dispatch(stopLoading());
        } else if (json.length === 1 && json[0].sequence_2 !== "") {
          dispatch(setStepByPass(getState().activeStep, true));
          const element = {
            textItem: json[0].libelle,
            stepItem: getState().activeStep
          };
          dispatch(setItemBreadcrumbs(element));
          dispatch(setReturnedValue({ appointmentType: json[0].id }));

          dispatch(getProtocol(json[0].sequence_2));
        } else {
          const step = searchStepByCode(getState().steps, "typeConsultation");
          if (!step) {
            const subStep = createStep({
              code: "typeConsultation",
              label: "Quel type de consultation souhaitez-vous ?",
              component: {
                type: ChooserTypeConsultation,
                label: "Type de consultation"
              },
              data: {
                fetchSource: getTypeConsultation,
                keyValue: "typeConsultation"
              },
              returned: {
                key: "typeConsultation"
              }
            });
            dispatch(
              addSubStep(
                getState().activeStep.step,
                subStep,
                getState().activeStep.subStep
              )
            );
          }

          dispatch(
            goToNextStep(
              "appointmentType",
              json,
              json.length === 1,
              json.length === 1 ? json[0].id : null
            )
          );
        }
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getTypeConsultation = () => {
  return (dispatch, getState) => {
    fetcher()
      .get("ajax/check_status_widget_motif_rdv.php", {
        searchParams: { id: getReturnedValue("appointmentType") }
      })
      .then(response => response.json())
      .then(json => {
        // if 'normal'
        if (json.result === "Telconsult") {
          dispatch(setReturnedValue({ typeConsultation: "teleconsult" }));
          fetcher(true, { telconsul: "ok" });
          dispatch(
            alertDialog(
              `<p></p><p></p>${translator()._("W_MESSAGE_TELECONSULTATION")}`
            )
          );
          dispatch(alertDialogGoToNext(true));
          dispatch(setStepByPass(getState().activeStep, true));
        } else {
          fetcher(true, {}, ["telconsul"]);
          dispatch(
            goToNextStep(
              "typeConsultation",
              json,
              json.result === "Normal",
              null
            )
          );
        }
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getAppointmentTypeSequence = () => {
  return (dispatch, getState) => {
    fetcher()
      .get("ajax/sequence_type_rdv.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idtyperdv: getReturnedValue("appointmentType"),
          provenance: "web"
        }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(stopLoading());
        if (json[0].bbtcodeprioritaire === "ok") {
          dispatch(setShowCodePrioritaire(true));
        } else {
          if (json[0].message_2) {
            dispatch(alertDialog(json[0].message_2));
          }
          if (json.length && json[0].bcontinue === "nop") {
            dispatch(alertDialogGoToBeginning(true));
            if (!json[0].message_2) {
              dispatch(alertDialog(""));
            }
          } else if (json[0].message_2 && json[0].bcontinue === "ok") {
            dispatch(setStepByPass(getState().activeStep, true));
            dispatch(alertDialogGoToNext(true));
          } else {
            dispatch(
              goToNextStep(
                "appointmentTypeSequence",
                json,
                json.length === 1,
                null
              )
            );
          }
        }
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getAppointmentLocation = () => {
  return dispatch => {
    fetcher()
      .get("ajax/widget_liste_lieux.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idtyperdv: getReturnedValue("appointmentType"),
          provenance: "web",
          all: "1"
        }
      })
      .then(response => response.json())
      .then(json => {
        const queryParams = new URLSearchParams(window.location.search);

        let fromUrl = queryParams.get("bypass_single_location");

        let fromRootDiv = document?.getElementById("root").dataset
          .bypass_single_location;

        let bypass = fromUrl ? fromUrl : fromRootDiv ? fromRootDiv : "true";
        if (Array.isArray(json) && json.length == 0) {
          dispatch(alertDialogGoToBeginning(true));
          dispatch(alertDialog(translator()._("W_AUCUN_RDV_DISPO")));
          dispatch(stopLoading());
        } else {
          dispatch(
            goToNextStep(
              "appointmentLocation",
              json,
              bypass === "true" && json.length === 1 ? true : false,
              json.length === 1 ? json[0].id : null,
              json.length === 1 ? json[0].libelle : null
            )
          );
        }
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getPractitioner = () => {
  return (dispatch, getState) => {
    fetcher()
      .get("ajax/widget_liste_praticien.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idtyperdv: getReturnedValue("appointmentType"),
          idlieux: getReturnedValue("appointmentLocation"),
          provenance: "web",
          all: "1"
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.length === 0) {
          if (getState().alertDialog.content) {
            dispatch(alertDialogGoToBeginning(true));
          } else {
            const subStep = createStep({
              component: {
                type: GoToLink
              },
              data: {
                fetchSource: () => ({ message: "Aucun praticien" })
              }
            });
            dispatch(
              addSubStep(
                getState().activeStep.step,
                subStep,
                getState().activeStep.subStep
              )
            );
            dispatch(nextStep(getState().steps));
          }
        } else {
          dispatch(
            goToNextStep(
              "practitioner",
              json,
              json.length === 1,
              json.length === 1 ? json[0].id : null,
              json.length === 1 ? json[0].praticien : null
            )
          );
        }
        dispatch(setPractitioners(json));
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getNbPeople = () => {
  return dispatch => {
    fetcher()
      .get("ajax/nb_personne.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idp: getReturnedValue("practitioner"),
          idtyperdv: getReturnedValue("appointmentType"),
          provenance: "web"
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Object.values(json);
        dispatch(
          goToNextStep(
            "nbPeople",
            json,
            json.length === 1 ? true : false,
            json.length === 1 ? json[0] : null
          )
        );
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getAvailableAppointment = () => {
  return (dispatch, getState) => {
    const { name, value } = getState().dateSurvey;
    let params = {
      idprofession: getReturnedValue("profession"),
      idp: getReturnedValue("practitioner"),
      idtyperdv: getReturnedValue("appointmentType"),
      idlieux: getReturnedValue("appointmentLocation"),
      nbpersonne: getReturnedValue("nbPeople"),
      filtreall: getReturnedValue("fullSearch")
    };

    if (name) {
      params[name] = value;
    }

    fetcher()
      .get("ajax/rdv_disponible_ajax.php", {
        searchParams: params
      })
      .then(response => response.json())
      .then(json => {
        const subStep = processAppointments(json);
        dispatch(addSubStep(getState().activeStep.step, subStep, false));

        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getAvailableAppointmentCalendar = () => {
  return (dispatch, getState) => {
    fetcher()
      .get("ajax/rdv_disponible_calendar_ajax.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idp: getReturnedValue("practitioner"),
          idtyperdv: getReturnedValue("appointmentType"),
          idlieux: getReturnedValue("appointmentLocation"),
          nbpersonne: getReturnedValue("nbPeople"),
          filtreall: getReturnedValue("fullSearch")
        }
      })
      .then(response => response.json())
      .then(json => {
        // init stack with current date
        CalendarHelper.add(DateTime.local(), true);
        const subStep = processAppointments(json);
        dispatch(addSubStep(getState().activeStep.step, subStep, false));

        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const nextAppointments = date => {
  return dispatch => {
    fetcher()
      .get("ajax/rdv_disponible_calendar_ajax.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idp: getReturnedValue("practitioner"),
          idtyperdv: getReturnedValue("appointmentType"),
          idlieux: getReturnedValue("appointmentLocation"),
          nbpersonne: getReturnedValue("nbPeople"),
          datesemaine: date
        }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(addFieldData("appointment", json));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const searchAvailableAppointment = ({
  datedebutdispo,
  day,
  timeSlot
}) => {
  return dispatch => {
    fetcher()
      .get("ajax/rdv_disponible_calendar_ajax.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idp: getReturnedValue("practitioner"),
          idtyperdv: getReturnedValue("appointmentType"),
          idlieux: getReturnedValue("appointmentLocation"),
          nbpersonne: getReturnedValue("nbPeople"),
          datedebutdispo: datedebutdispo,
          date: day,
          creneauhoraire: timeSlot
        }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(addFieldData("appointment", json));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const searchAvailableAppointmentList = ({
  datedebutdispo,
  day,
  timeSlot
}) => {
  return dispatch => {
    fetcher()
      .get("ajax/rdv_disponible_ajax.php", {
        searchParams: {
          idprofession: getReturnedValue("profession"),
          idp: getReturnedValue("practitioner"),
          idtyperdv: getReturnedValue("appointmentType"),
          idlieux: getReturnedValue("appointmentLocation"),
          nbpersonne: getReturnedValue("nbPeople"),
          datedebutdispo: datedebutdispo,
          date: day,
          creneauhoraire: timeSlot
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.length > 0 && json[0].success === 0) {
          dispatch(addFieldData("appointment", null));
          dispatch(setMessage(json[0].message_error));
        } else {
          dispatch(addFieldData("appointment", json));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};
